import { FeeTierDto, FeeTierRangeDto, StripeFeeTierDto } from '../models/dto';

export const requiredFeeTierRanges: FeeTierRangeDto[] = [
	{ min: 0, max: 50_00 },
	{ min: 50_00, max: 150_00 },
	{ min: 150_00, max: 300_00 },
	{ min: 300_00 }
];

export const feeTiers: FeeTierDto[] = [
	{
		min: 0, // $0
		max: 50_00, // $50.00
		defaultPercent: 7.9, // 7.9%
		proPercent: 11.9, // 11.9%,
		posPercent: 3, // 3%
	},
	{
		min: 50_00, // $50.00
		max: 150_00, // $150.00
		defaultPercent: 6.9, // 6.9%
		proPercent: 10.9, // 10.9%
		posPercent: 3, // 3%
	},
	{
		min: 150_00, // $150.00
		max: 300_00, // $300.00
		defaultPercent: 5.9, // 5.9%
		proPercent: 9.9, // 9.9%
		posPercent: 3, // 3%
	},
	{
		min: 300_00, // $300.00
		defaultPercent: 2.9, // 2.9%
		proPercent: 2.9, // 2.9%
		posPercent: 3, // 3%
	},
];

export const stripeFeeTiers: StripeFeeTierDto[] = [
	{
		min: 0, // $0
		max: 50_00, // $50.00
		fixed: 49, // $0.49
		percent: 2.9, // 2.9%
		posFixed: 0, // $0.00
		posPercent: 2.9, // 2.9%
	},
	{
		min: 50_00, // $50.00
		fixed: 99, // $0.99
		percent: 2.9, // 2.9%
		posFixed: 0, // $0.00
		posPercent: 2.9, // 2.9%
	},
];
